import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import MovieHero from '../components/MovieHero';
import SearchBar from '../components/SearchBar';
import Character from '../components/Character';
import FooterBar from '../components/FooterBar';
import Loader from '../components/Loader';

import { GlobalStyle } from '../GlobalStyles';

import { api } from '../components/api';

const MoviePage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [movieData, setMovieData] = useState('');
  const [cast, setCast] = useState('');
  const { id } = useParams();

  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    setErrorMsg('');
    setIsLoading(true);
    const fetchMovieData = async () => {
      try {
        const resp = await fetch(
          `${api.url}${api.movie}/${id}?api_key=${api.apiKey}&append_to_response=credits,videos`
        );
        const data = await resp.json();
        setMovieData(() => ({
          id: data.id,
          title: data.title,
          overview: data.overview,
          backdrop: data.backdrop_path,
          poster_path: data.poster_path,
          vote_average: data.vote_average,
          trailer: '',
        }));

        if (data.credits) {
          setCast(() => data.credits.cast);
        } else {
          setErrorMsg('No cast found');
        }
        if (data.videos.results.length >= 1) {
          setMovieData((prevData) => ({
            ...prevData,
            trailer: data.videos.results[0].key,
          }));
        }

        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setErrorMsg('Sorry, there was an error');
        console.log('ERROR: ', error);
      }
    };

    fetchMovieData();
  }, [id]);

  if (isLoading || !movieData) {
    return (
      <div className='app-wrapper'>
        <Navbar />
        <SearchBar />
        <Loader />
        <FooterBar />
        <GlobalStyle />
      </div>
    );
  }

  if (errorMsg) {
    return (
      <div className='app-wrapper'>
        <Navbar />
        {/* searchbar */}
        <SearchBar />

        <div className='page-container'>
          <div className='message'>
            <h2>{errorMsg}</h2>
            <p>Please try another search</p>
          </div>
        </div>

        <FooterBar />
        <GlobalStyle />
      </div>
    );
  }

  return (
    <div className='app-wrapper'>
      <Navbar />
      <MovieHero movieData={movieData} isLoading={isLoading} />
      {/* searchbar */}
      <SearchBar />
      {/* popular movies */}
      <div className='section-heading'>
        <h4>{movieData.title} Cast</h4>
      </div>
      <div className='block-wrapper'>
        {cast.map((cast) => {
          return <Character key={cast.id} cast={cast} />;
        })}
      </div>
      <FooterBar />

      <GlobalStyle />
    </div>
  );
};

export default MoviePage;
